module.exports = __webpack_public_path__ + "img/gift.35041018.svg";